import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// --- UPDATED: Accept 'reportPeriod' as a prop ---
const HoursByPropertyChart = ({ chartData, reportPeriod }) => {
  const data = {
    labels: chartData.labels || [],
    datasets: chartData.datasets || [],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        // --- UPDATED: Use the prop to create a dynamic title ---
        text: `Hours by Property and Employee for ${reportPeriod}`,
        font: {
          size: 18
        }
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Properties'
        }
      },
      y: {
        title: {
          display: true,
          text: 'Hours Worked'
        },
        beginAtZero: true
      }
    }
  };

  return (
    <div className="card" style={{ height: '450px' }}>
      <Bar options={options} data={data} />
    </div>
  );
};

export default HoursByPropertyChart;